import { FC } from 'react'
import { AppraisalStepBtns } from '../appraisal-flow/shared/appraisal-types'
import { MeetingStep, MeetingStepStatus } from '../../../types'
import PerFlexRow from '../../../components/custom_components/FlexRow'

interface Props extends AppraisalStepBtns {
  meetingId?: number
  nextStep?: MeetingStep
  previousStep?: MeetingStep
  currentStepStatus: MeetingStepStatus
}

export const EvaluationStepButtonsComponent: FC<Props> = ({ backBtn, nextBtn, currentStepStatus }) => {
  return (
    <PerFlexRow justify="space-between">
      {backBtn && backBtn(currentStepStatus)}
      <PerFlexRow align="middle">{nextBtn && nextBtn(currentStepStatus)}</PerFlexRow>
    </PerFlexRow>
  )
}
